<template>
  <div class="about-view">

    <!-- 宽屏状态下 -->
    <div class="about-content" v-if="bShowLargeContent">

      <div class="about-content-item">
        <div class="about-item-col">
          <h2 class="about-item-title">我们是谁</h2>
          <span class="about-item-desc">
            易软信息科技（惠州）有限公司是一家长期致力于办公工具的开发，针对性解决用户痛点的自主研发的新兴企业。始终坚持自主研发，技术创新的理念，以技术研发作为第一生产力，解决用户需求为终点，以匠人精神做好产品与服务，用优质的产品与服务，全力去赢得越来越多用户与市场的认同。我们的目标是助力全球用户实现更简便、更快捷、更高效的生活和工作。
          </span>
        </div>

        <span style="width: 100px;"></span>

        <img class="item-img" src="/images/about/bg1.png" />
      </div>

      <span style="height: 160px;"></span>

      <div class="about-content-item">
        <img class="item-img" src="/images/about/bg2.png" />

        <span style="width: 100px;"></span>

        <div class="about-item-col">
          <h2 class="about-item-title">联系我们</h2>

          <div class="about-item-row">
            <span>公司名：易软信息科技（惠州）有限公司</span>
          </div>

          <div class="about-item-row">
            <span>地址：惠州市博罗县龙华镇龙华村红心组横陂</span>
          </div>

          <div class="about-item-row">
            <span>电话：13143098453</span>
          </div>

          <div class="about-item-row">
            <span>邮箱：esofttech@163.com</span>
          </div>

          <div class="about-item-row">
            <span>QQ群：1076462304</span>
          </div>
        </div>
      </div>

    </div>

    <!-- 窄屏状态下 -->
    <div class="about-content" v-if="!bShowLargeContent">

      <div class="about-content-item">
        <div class="about-item-col">
          <h2 class="about-item-title">我们是谁</h2>
          <span class="about-item-desc">
            易软信息科技（惠州）有限公司是一家长期致力于办公工具的开发，针对性解决用户痛点的自主研发的新兴企业。始终坚持自主研发，技术创新的理念，以技术研发作为第一生产力，解决用户需求为终点，以匠人精神做好产品与服务，用优质的产品与服务，全力去赢得越来越多用户与市场的认同。我们的目标是助力全球用户实现更简便、更快捷、更高效的生活和工作。
          </span>
        </div>

        <img class="item-img" src="/images/about/bg1.png" />
      </div>

      <div class="about-content-item">
        <div class="about-item-col">
          <h2 class="about-item-title">联系我们</h2>

          <div class="about-item-row">
            <span>公司名：易软信息科技（惠州）有限公司</span>
          </div>

          <div class="about-item-row">
            <span>地址：惠州市博罗县龙华镇龙华村红心组横陂</span>
          </div>

          <div class="about-item-row">
            <span>电话：13143098453</span>
          </div>

          <div class="about-item-row">
            <span>邮箱：esofttech@163.com</span>
          </div>

          <div class="about-item-row">
            <span>QQ群：1076462304</span>
          </div>
        </div>
        <img class="item-img" src="/images/about/bg2.png" />
      </div>

    </div>
  </div>
</template>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})

import * as VueUse from '@vueuse/core'

/* 屏幕 >= 1320px时 */
const bShowLargeContent = VueUse.useMediaQuery('(min-width: 1320px)')
</script>

<style>
.about-view {
  background-color: white;
}

.flexbox-spacer {
  flex-grow: 1;
}

@media (max-width: 1319px) {
  .about-content {
    margin: 0 10%;
    padding: 32px 0 32px 0;
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .about-content-item {
    width: 100%;
    height: fit-content;
    flex-direction: column;
    display: flex;
    padding: 0 16px;
    align-items: center;
  }

  .about-item-col {
    display: flex;
    width: 100%;
    flex-direction: column;
  }

  .about-item-title {
    color: rgba(0, 0, 0, 0.8);
    font-size: 20px;
    font-weight: 700;
    width: fit-content;
    margin: 0;
    border-bottom: 2px solid rgba(82, 153, 255, 1);
  }

  .about-item-desc {
    margin-top: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    line-height: 24px;
  }

  .item-img {
    height: fit-content;
    width: 100%;
    object-fit: cover;
    margin-top: 16px;
    margin-bottom: 42px;
  }

  .about-item-row {
    display: flex;
    align-items: center;
    font-weight: 400;
    margin-top: 12px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    text-decoration: none;

    p {
      display: none;
    }
    img {
      height: 20px;
      width: 20px;
      margin-right: 8px;
    }
  }
}

@media (min-width: 1320px) {
  .about-content {
    padding: 32px 0 32px 0;
    width: 100%;
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .about-content-item {
    height: 360px;
    display: flex;
    align-items: center;
  }

  .about-item-col {
    display: flex;
    width: 540px;
    flex-direction: column;
  }

  .about-item-title {
    color: rgba(0, 0, 0, 0.8);
    font-size: 48px;
    font-weight: 700;
    width: fit-content;
    margin: 0;
    border-bottom: 4px solid rgba(82, 153, 255, 1);
  }

  .about-item-desc {
    margin-top: 36px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    font-size: 16px; 
    line-height: 32px;
  }

  .item-img {
    height: 100%;
    width: 640px;
    object-fit: cover;
  }

  .about-item-row {
    display: flex;
    align-items: center;
    font-weight: 400;
    margin-top: 12px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 16px; 
    text-decoration: none;
  }
}
</style>
